import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {DynamicSlotName} from '../../../../lib/DynamicSlotName'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {DynamicSlot} from '../../../dynamic/DynamicSlot'
import {TransactionInfoTransactionDetails} from './TransactionInfoTransactionDetails'
import {TransactionInfoPaymentMethodDetails} from './TransactionInfoPaymentMethodDetails'
import {TransactionInfoCustomerDetails} from './TransactionInfoCustomerDetails'

///////////////////////////////////////////////////////////////////////////////

export const TransactionInfo = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const transactionInfo = api.transactionInfo

  if (!transactionInfo) {
    return null
  }

  return (
    <section className="transaction-info">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans('blocks.transaction_info.subtitle')}
          </h2>
        </div>
      </div>

      <div className="main">
        <DynamicSlot name={DynamicSlotName.TRANSACTION_INFO_START} />

        <TransactionInfoTransactionDetails />

        <DynamicSlot name={DynamicSlotName.TRANSACTION_INFO_1} />

        <TransactionInfoPaymentMethodDetails />

        <DynamicSlot name={DynamicSlotName.TRANSACTION_INFO_2} />

        <TransactionInfoCustomerDetails />

        <DynamicSlot name={DynamicSlotName.TRANSACTION_INFO_END} />
      </div>
    </section>
  )
})
